"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    job: 'Jobb' || 'job',
    createJob: 'Skapa jobb' || 'createJob',
    startJob: 'Starta jobb' || 'startJob',
    resetJob: 'Återställ jobb' || 'resetJob',
    stopJob: 'Stanna jobb' || 'stopJob',
    runStandaloneJob: 'Kör ett flaivy-cli job i en separat batch' || 'runStandaloneJob',
    activate: 'Aktivera' || 'activate',
    deactivate: 'Inaktivera' || 'deactivate',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    name: 'Namn' || 'name',
    description: 'Beskrivning' || 'description',
    active: 'Aktiverad' || 'active',
    expectedRunInterval: 'Kör' || 'expectedRunInterval',
    expectedRunIntervals: {
        300: 'var femte minut' || '300',
        3600: 'varje timme' || '3600',
        86400: 'varje dag' || '86400',
        604800: 'varje vecka' || '604800',
        2628000: 'varje månad' || '2628000',
    },
    status: 'Status' || 'status',
    statuses: {
        Error: 'Fel' || 'Error',
        Success: 'OK' || 'Success',
        Started: 'Kör just nu' || 'Started',
        Undetermined: 'Något har hänt, kommer försöka igen' || 'Undetermined',
    },
    lastSuccess: 'Senaste lyckade körning' || 'lastSuccess',
    startedAt: 'Senaste lyckade körning' || 'startedAt',
    isOverdue: 'Borde ha körts' || 'isOverdue',
    runs: {
        id: 'Identitet' || 'id',
        status: 'Status' || 'status',
        statuses: {
            Error: 'Fel' || 'Error',
            Success: 'OK' || 'Success',
            Started: 'Kör just nu' || 'Started',
            Undetermined: 'Något har hänt, kommer försöka igen' || 'Undetermined',
        },
        start: 'Startad' || 'start',
        end: 'Avslutad' || 'end',
        message: 'Felmeddelande' || 'message',
        error: 'Teknisk information om fel' || 'error',
    },
};
